import { generateApiActionTypes } from 'utils/actions/generateActionTypes'
import { ENDPOINTS } from 'utils/api/callApi'
import {
  ISpotBiddingConfigsParams,
  ISpotBiddingConfigsFilterState,
} from 'apps/spot-quote-control-panel/types/spotBiddingConfig'

export const GET_SPOT_BIDDING_CONFIG_LIST_ACTION_TYPES = generateApiActionTypes(
  'GET_SPOT_BIDDING_CONFIG_LIST'
)
export const getSpotBiddingConfigList = (params: ISpotBiddingConfigsParams) => {
  return {
    payload: {
      callApi: true,
      requestData: {
        endpoint: ENDPOINTS.spotBiddingConfigs,
        method: 'GET',
        params,
      },
      actionTypes: Object.keys(GET_SPOT_BIDDING_CONFIG_LIST_ACTION_TYPES),
    },
    type: '',
  }
}

export const UPDATE_CONFIG_FILTERS = 'UPDATE_CONFIG_FILTERS'
export const updateConfigFilters = (filters: Partial<ISpotBiddingConfigsFilterState>) => ({
  type: UPDATE_CONFIG_FILTERS,
  payload: { filters },
})

export const UPDATE_PAGE_COUNT = 'UPDATE_PAGE_COUNT'
export const updatePageCount = (pageCount: number) => ({
  type: UPDATE_PAGE_COUNT,
  payload: { pageCount },
})
